var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadVsgId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8171_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 9.41675L19.1514 8.56822L19.9999 7.71969L20.8484 8.56822L19.9999 9.41675ZM21.1999 19.1667C21.1999 19.8295 20.6627 20.3667 19.9999 20.3667C19.3372 20.3667 18.7999 19.8295 18.7999 19.1667L21.1999 19.1667ZM13.7347 13.9849L19.1514 8.56822L20.8484 10.2653L15.4318 15.6819L13.7347 13.9849ZM20.8484 8.56822L26.2651 13.9849L24.5681 15.6819L19.1514 10.2653L20.8484 8.56822ZM21.1999 9.41675L21.1999 19.1667L18.7999 19.1667L18.7999 9.41675L21.1999 9.41675Z",
    fill: "#CE1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 21.3333L12.4167 22.4166C12.4167 23.6132 13.3868 24.5833 14.5834 24.5833L25.4167 24.5833C26.6134 24.5833 27.5834 23.6132 27.5834 22.4166V21.3333",
    stroke: "#CE1F1F",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4167,
    y: 20.25,
    width: 15.1667,
    height: 4.33333,
    rx: 2,
    fill: "#7E869E",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8171_2546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadVsgId);
export default __webpack_public_path__ + "static/media/download_vsg_ID.dd1ff0ea92daf4977432a474ba8c93d1.svg";
export { ForwardRef as ReactComponent };